import { api, WorkspacesAPITagType } from '@/api/api'
import getWorkspaceApiUrl from '@/api/utils/get-workspace-api-url'
import type { EditCustomizedLabelRequest } from '@/types/schema/directory/kol-management'

const customizedLabelsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    editCustomizedLabel: builder.mutation<void, EditCustomizedLabelRequest>({
      query: ({ id, customized_label }) => {
        return {
          url: getWorkspaceApiUrl(`/customized-labels/${id}`, 'v3'),
          method: 'PATCH',
          body: { customized_label },
        }
      },
      invalidatesTags: [
        WorkspacesAPITagType.CustomizedLabels,
        WorkspacesAPITagType.DirectoryKolBasicInfo,
        WorkspacesAPITagType.KolManagement,
        WorkspacesAPITagType.KolCollectionKols,
      ],
    }),
    deleteCustomizedLabel: builder.mutation<void, number>({
      query: (id) => {
        return {
          url: getWorkspaceApiUrl(`/customized-labels/${id}`, 'v3'),
          method: 'DELETE',
        }
      },
      invalidatesTags: [
        WorkspacesAPITagType.CustomizedLabels,
        WorkspacesAPITagType.DirectoryKolBasicInfo,
        WorkspacesAPITagType.KolManagement,
        WorkspacesAPITagType.KolCollectionKols,
      ],
    }),
  }),
  overrideExisting: false,
})

export const {
  useEditCustomizedLabelMutation,
  useDeleteCustomizedLabelMutation,
} = customizedLabelsApi
